var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"buttons-holder"},[_c('a-button',{staticClass:"clientinfo-button",attrs:{"type":"primary","size":"large"},on:{"click":_vm.write}},[_vm._v(" Сохранить ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }